// Copyright (c) 2020 Deere & Company

import SpecialAllowanceClaimStatusReport from '../../../reports/special-allowance-claim-status/state-connector';

export default {
    component: SpecialAllowanceClaimStatusReport,
    name: 'SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM',
    path: 'special-allowance-claim-status'
};



// WEBPACK FOOTER //
// ./src/routes/tabm/reports/special-allowance-claim-status.js